export const ViewContentTiktokPixel = ({
  category,
  currency,
  productId,
  productName,
  productPrice,
}) => {
  if (window?.ttq !== undefined) {
    window.ttq.track('ViewContent', {
      content_type: 'product',
      content_id: productId,
      content_name: productName,
      content_category: category,
      currency,
      value: productPrice,
    });
  }
};

export const AddToCartTikTokEvent = ({ currency, productId, productName, productPrice }) => {
  if (window?.ttq !== undefined) {
    window.ttq.track('AddToCart', {
      content_type: 'product',
      content_id: productId,
      content_name: productName,
      value: productPrice,
      currency,
    });
  }
};

export const AddPaymentInfoTiktokEvent = ({ productIds, totalAmount, totalItems, currency }) => {
  if (window?.ttq !== undefined) {
    window.ttq.track('AddPaymentInfo', {
      content_type: 'product',
      content_id: productIds.toString(),
      value: totalAmount,
      quantity: totalItems,
      currency,
    });
  }
};

export const InitiateCheckoutTiktokEvent = ({ productIds, totalAmount, totalItems, currency }) => {
  if (window?.ttq !== undefined) {
    window.ttq.track('InitiateCheckout', {
      content_type: 'product',
      content_id: productIds.toString(),
      currency,
      value: totalAmount,
      quantity: totalItems,
    });
  }
};

export const TiktokPixelEvent = (event = '', cartData) => {
  const cartItems = cartData?.result?.items || [];
  const productIds = cartItems.map(item => item.productId);
  const productNames = cartItems.map(item => item.name);
  const totalAmount = cartData?.result?.totals?.total || 0;
  const currency = cartData?.result?.totals?.currencyCode || '';

  if (window?.ttq !== undefined) {
    window.ttq.track(event, {
      content_type: 'product',
      content_id: productIds.toString(),
      content_name: productNames.toString(),
      currency,
      value: totalAmount,
    });
  }
};

export const PlaceAnOrderTiktokEvent = ({
  currency,
  productIds,
  productCategories,
  totalItems,
  totalAmount,
}) => {
  if (window?.ttq !== undefined) {
    window.ttq.track('PlaceAnOrder', {
      content_type: 'product',
      content_id: productIds.toString(),
      content_category: productCategories.toString(),
      currency,
      quantity: totalItems,
      value: totalAmount,
    });
  }
};
